import React from 'react';

export interface PedidosIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const PedidosIcon: React.FC<PedidosIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16.993 4.916h2.083A2.083 2.083 0 0 1 21.16 7v14.583a2.083 2.083 0 0 1-2.084 2.083h-12.5a2.083 2.083 0 0 1-2.083-2.083V7a2.083 2.083 0 0 1 2.083-2.084H8.66M9.7 2.833h6.25c.576 0 1.042.466 1.042 1.042v2.083c0 .575-.466 1.042-1.042 1.042H9.7a1.04 1.04 0 0 1-1.04-1.042V3.875c0-.576.466-1.042 1.041-1.042"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M11.493 11.164h6.302m-9.937 0h.559m3.076 3.407h6.302m-9.937 0h.559m3.076 3.499h6.302m-9.937 0h.559"/>
    </svg>
  );
};

export default PedidosIcon;
